import React from 'react'
import { LoginResponseType } from '../../../redux/auth/authTypes';

type AppProps = {
    jobsData: any;
    loginData?:LoginResponseType;
    handleChange: (data: any, name: string) => void;
    singlejobsData:any;
}

const PaymentStructure = ({ jobsData, handleChange ,singlejobsData,loginData }: AppProps) => {
    return (
        <div className='row'>
            <div className="col-md-4">
                <div className="form-group mt-3">
                    <div>
                        <label
                            htmlFor="actionName"
                        >
                            Agreed Fees
                        </label>
                        <input
                            type="text"
                            className={`form-control`}
                            name="agreedFees"
                            value={jobsData?.agreedFees ? jobsData?.agreedFees : ""}
                            onChange={(e: any) => handleChange(e, "agreedFees")}
                            disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                        {/* <div>{!!jobsError?.shortCode && <small className="text-danger">{jobsError?.shortCode}</small>}</div> */}
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group mt-3">
                    <div>
                        <label
                            htmlFor="actionName"
                        >
                            Budget Total
                        </label>
                        <input
                            type="text"
                            className={`form-control`}
                            name="budgetTotal"
                            value={jobsData?.budgetTotal ? jobsData?.budgetTotal : ""}
                            onChange={(e: any) => handleChange(e, "budgetTotal")}
                            disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                        {/* <div>{!!jobsError?.shortCode && <small className="text-danger">{jobsError?.shortCode}</small>}</div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentStructure